import {
  apiAuthConstructor as apiAuth,
  apiConstructor as api,
} from '@/api/apiConstructor';
import { AxiosResponse } from 'axios';
import { Credentials } from '@/types/user';

export async function login(credentials: Credentials): Promise<any> {
  try {
    const response: AxiosResponse = await apiAuth.post('/oauth/token', {
      grant_type: 'password',
      client_id: process.env.VUE_APP_OAUTH_CLIENT_ID,
      client_secret: process.env.VUE_APP_OAUTH_CLIENT_SECRET,
      username: credentials.email,
      password: credentials.password,
      scope: '',
    });
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function getMe(): Promise<any> {
  try {
    const response: AxiosResponse = await api.get('get-user');
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}
